module.exports = __webpack_public_path__ + "Roboto-BoldItalic.a7dce23c0dd99a4afa5c.woff";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-BoldItalic.woff
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BoldItalic.woff
// module chunks = styles